import { __rest } from "tslib";
import React, { forwardRef } from "react";
import { useSpring, animated as A } from "react-spring";
import { Help } from "../Icons";
import Tooltip from "../Tooltip";
import AnimatedCheck from "./AnimatedCheck";
import { setTooltipIconColor } from "./helpers";
import * as S from "./styles";
export var Input = forwardRef(function (e, t) {
  var a = e.autoComplete,
      o = e.className,
      l = e.disabled,
      r = e.error,
      _e$footerStyle = e.footerStyle,
      i = _e$footerStyle === void 0 ? !1 : _e$footerStyle,
      p = e.id,
      n = e.inputClassName,
      s = e.label,
      c = e.name,
      m = e.onChange,
      d = e.placeholder,
      u = e.type,
      b = e.validated,
      f = e.value,
      h = e.tooltip,
      C = e.tooltipProps,
      R = e.helperText,
      E = __rest(e, ["autoComplete", "className", "disabled", "error", "footerStyle", "id", "inputClassName", "label", "name", "onChange", "placeholder", "type", "validated", "value", "tooltip", "tooltipProps", "helperText"]),
      T = p + "-error",
      y = useSpring({
    opacity: r ? 1 : 0
  });

  return React.createElement(S.InputWrapper, {
    error: r,
    "data-error": r,
    className: o,
    validated: b,
    disabled: l,
    footerStyle: i,
    addBottomMargin: !r && !R
  }, React.createElement(S.Input, Object.assign({
    id: p,
    autoComplete: a,
    ref: t,
    name: c,
    type: u,
    value: f,
    placeholder: d,
    disabled: l,
    className: n,
    "data-testid": p + "-input",
    "aria-describedby": T,
    "aria-invalid": !!r,
    onChange: m
  }, E)), s ? React.createElement(S.Label, {
    htmlFor: p,
    "data-testid": p + "-label",
    hasTooltip: !!h
  }, s, h && React.createElement(Tooltip, Object.assign({
    content: h,
    animationSpeed: "normal",
    position: "top",
    arrow: "center",
    className: "labelTooltip",
    tooltipBoxClass: "labelTooltipBox"
  }, C), React.createElement(Help, {
    className: "labelTooltipIcon",
    color: setTooltipIconColor(!!r, !!l),
    hasError: r,
    isDisabled: l
  }))) : React.createElement(S.HiddenLabel, {
    htmlFor: p,
    "data-testid": p + "-label"
  }, p), React.createElement(S.CheckWrapper, null, React.createElement(AnimatedCheck, {
    isValid: b
  })), (r ? React.createElement(S.Error, {
    id: T,
    "data-testid": T
  }, React.createElement(A.span, {
    style: y
  }, r)) : null) || (R ? React.createElement(S.HelperText, null, R) : null));
});
export default Input;